import { Routes } from '@angular/router';

import { ERoutes } from '../../types/app-routes';
import { CardCanDeactivateGuard } from '../../services/card-can-deactivate-guard.service';

export const organizationsRoutes: Routes = [
  {
    path: ERoutes.ORGANIZATIONS,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./organizations-table/organizations-table.component').then(
            (m) => m.OrganizationsTableComponent
          ),
      },
      {
        path: 'card',
        canDeactivate: [CardCanDeactivateGuard],
        loadComponent: () =>
          import('./organizations-card/organizations-card.component').then(
            (m) => m.OrganizationsCardComponent
          ),
      },
    ],
  },
];
